import React, { useContext, useEffect } from "react";
import { Button, ButtonGroup, Divider, Stack, Typography } from "@mui/material";
import { checkModes } from "./config";
import { QuestionsContext, ReviewContext } from "../../../provider/MyContexts";
import DetailSetting from "./DetailSegging";
import FileUploadArea from "./elements/FileUploadArea";
import { loadSheetValues } from "../../../commands/questions/excelInfo";

type Props = {
  handleChangeMode: (mode: string) => void;
  checkMode: string;
};

export default function ReviewSetting(props: Props) {
  const { handleChangeMode, checkMode } = props;

  const { questions, updateQuestions, editSheet } = useContext(QuestionsContext);
  const { handleExcelReview } = useContext(ReviewContext);

  async function loadSheetData() {
    const { questions, checkResultsExcel } = await loadSheetValues(editSheet);
    updateQuestions(questions, true);
  }

  useEffect(() => {
    if (checkMode === checkModes[0] && editSheet) {
      loadSheetData();
    }
  }, [checkMode, editSheet]);

  function switchContent() {
    switch (checkMode) {
      case checkModes[0]:
        return (
          <Stack padding={2} spacing={2} flex={1}>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              padding={1}
              width={"100%"}
            >
              <Button
                variant="contained"
                onClick={async () => {
                  handleExcelReview();
                }}
                disabled={questions.length === 0}
                sx={{
                  width: 200,
                }}
              >
                <Typography variant="button">チェックする</Typography>
              </Button>
            </Stack>
            <Divider variant="middle" />
            <DetailSetting />
          </Stack>
        );
      case checkModes[1]:
        return <FileUploadArea />;

      default:
        return <></>;
    }
  }

  return (
    <Stack
      flex={1}
      direction={"column"}
      alignItems={"top"}
      justifyContent={"center"}
      spacing={2}
      width={"100%"}
      sx={{
        position: "sticky",
        top: 0,
      }}
    >
      <ButtonGroup aria-label="Basic button group">
        <Button
          variant={checkMode == checkModes[1] ? "contained" : "outlined"}
          onClick={() => handleChangeMode(checkModes[1])}
        >
          <Typography variant="button">過去結果をインポートする</Typography>
        </Button>
        <Button
          variant={checkMode == checkModes[0] ? "contained" : "outlined"}
          onClick={() => handleChangeMode(checkModes[0])}
        >
          <Typography variant="button">あたらしくチェックする</Typography>
        </Button>
      </ButtonGroup>
      <Divider variant="middle" />
      {switchContent()}
    </Stack>
  );
}
